export const HTTP_STATUS_CODE = {
  OK: 200,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  INTERNAL_SERVER_ERROR: 500,
};

export const HTTP_STATUS_MESSAGE = {
  TRY_AGAIN_OR_CONTACT_CLIENT_MANAGER: 'Please try again, if the issue persists, please contact your client manager.',
};

export const HTTP_ERROR_CODE = {
  ACCOUNT_NOT_VERIFIED: 'unverified_account',
  CONTACT_CLIENT_MANAGER: 'contact_client_manager',
  MISSING_PERMISSIONS: 'missing_permissions',
  INSUFFICIENT_ROLE: 'insufficient_role',
};
